// The Promise polyfill is loaded in a sync manner since dynamic-import uses it, this is why it's loaded at the top.
// We don't want to override the native Promise in case the browser has one, this is why we use require here.
if (!window.Promise) {
  require('core-js/fn/promise');
}

import sharedPolyfills from '@adsk/bim360-matrix-react-components/es/polyfills';

const loadAllPolyfills = () => {
  const polyfills = [
    () => Promise.all(sharedPolyfills()),
    () =>
      !window.Object.assign
        ? import(/* webpackChunkName: "core-js_object_assign" */ 'core-js/fn/object/assign')
        : null,
    () =>
      !window.Object.values
        ? import(/* webpackChunkName: "core-js_object_values" */ 'core-js/fn/object/values')
        : null,
    () =>
      !window.Array.prototype.find
        ? import(/* webpackChunkName: "core-js_array_find" */ 'core-js/fn/array/find')
        : null,
    () =>
      !window.Array.prototype.fill
        ? import(/* webpackChunkName: "core-js_array_fill" */ 'core-js/fn/array/fill')
        : null,
    () =>
      !window.Array.from
        ? import(/* webpackChunkName: "core-js_array_from" */ 'core-js/fn/array/from')
        : null,
    () =>
      !window.Array.prototype.findIndex
        ? import(/* webpackChunkName: "core-js_array_find_index" */ 'core-js/fn/array/find-index')
        : null,
    // react-onclickoutside uses classList and there cases where it's being used on an svg element but IE11 doesn't support classList for svg elements.
    // See http://caniuse.com/#feat=classlist
    () =>
      !document.createElementNS('http://www.w3.org/2000/svg', 'circle').classList
        ? import(/*webpackChunkName: "dom4-polyfill"*/ 'dom4')
        : null,
    () =>
      !window.Array.prototype.includes
        ? import(/* webpackChunkName: "core-js_array_includes" */ 'core-js/fn/array/includes')
        : null,
    () =>
      !window.Symbol ? import(/* webpackChunkName: "core-js_symbol" */ 'core-js/fn/symbol') : null,
    () =>
      !window.String.prototype.includes
        ? import(/* webpackChunkName: "core-js_string_includes" */ 'core-js/fn/string/includes')
        : null,
    () =>
      !window.String.prototype.endsWith
        ? import(/* webpackChunkName: "core-js_string_ends_with" */ 'core-js/fn/string/ends-with')
        : null,
    () =>
      !window.String.prototype.startsWith
        ? import(
            /* webpackChunkName: "core-js_string_starts_with" */ 'core-js/fn/string/starts-with'
          )
        : null,
    () =>
      !window.String.raw
        ? import(/* webpackChunkName: "core-js_string_raw" */ 'core-js/fn/string/raw')
        : null,
  ];

  return Promise.all(polyfills.map((polyfill) => polyfill())).then(() => {
    NodeList.prototype[Symbol.iterator] =
      NodeList.prototype[Symbol.iterator] || Array.prototype[Symbol.iterator];
  });
};

export default loadAllPolyfills;
